// Custom Hooks
import { useModal } from "./use-modal";
// Components
import { ProcessingModal } from "../components/Modals/ProcessingModal";

export const useProcessingModal = ({ text = "" }) => {
  const [onPresent, onDismiss] = useModal(<ProcessingModal text={text} />);
  return { onPresent, onDismiss };
};
